<template>
    <div class="InterInput">
        <div class="InterInput-label mb-1" v-if="label"
             :class="{ with_error: hasError}">
            {{label}}
        </div>
        <div class="InterInput-container" :class="[{disabled : disabled}, {with_error: hasError}]">
            <div v-bind:style="{backgroundColor : `#001ea0`}"
                    class="InterInput-icon fi" v-if="icon"
                 :class="[ {with_error: hasError}, 'flaticon-' + icon ]">
                <svg xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 100 100" preserveAspectRatio="none">
                    <polygon v-bind:style="{fill : `#001ea0`}" points="0,100 100,0 100,100"/>
                </svg>
            </div>
            <input
                :placeholder="placeholder"
                    autocomplete="off"
                    :disabled="disabled"
                    :type="type"
                    :class="`InterInput-input text-${textAlign}`"
                    :value="valueField"
                    v-on:input="$emit('input', $event.target.value)"
            />
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: "InterInput",
        directives: {focus: focus},
        props: {
            label: {
                required: false,
                type: [String,null],
                default: null
            },
            value: {
                type: [String, Number, null]
            },
            type: {
                type: [String],
                default: 'text'
            },
            textAlign: {
                type: [String],
                default: 'left'
            },
            placeholder: {
                type: [String, null],
                default: null
            },
            error: {
                type: [Boolean],
                default: false
            },
            disabled: {
                type: [Boolean],
                default: false
            },
            icon: {
                type: [String, null],
                default: null
            }
        },
        data() {
            return {
                hasError: false,
                valueField: ''
            }
        },
        mounted() {
            this.valueField = this.value;
        },
        watch: {
            error: function (val) {
                this.hasError = val;
            },
            value: function (val, oldVal) {
                this.valueField = this.value;
                if(val !== oldVal) {
                    this.hasError = false;
                }

                if (this.type === 'date-autocomplete' && val
                    && (val.length === 2 || val.length === 5)) {
                    this.valueField = val + '/';
                }
            },
        },
        computed: {
            ...mapGetters([
                'currentUser',
            ]),

            color: function() {
                return (this.currentUser && this.currentUser.color) ? this.currentUser.color : '#1A639A';
            }
        },
    }
</script>
